
<main>
  <section>
    <div class="container pt-120 pb-120 gx-5 gx-lg-0">
      <div class="col-lg-8 col-12">
        <form [formGroup]="searchForm" *ngIf="searchForm">
          <div class="search-container mb-5">
            <input type="text" formControlName="text" class="form-control search-input" placeholder="{{'formPlaceholders.pesquisa' | translate}}">
            <i class="uil uil-search fs-20px search-icon"></i>
          </div>
        </form>
      </div>
      <ng-container *ngIf="searchReady && fullListSize > 0">
        <div class="row">
          <div class="col-lg-10 col-12">
            <h6>{{searchInfo.Resultados}}</h6>
          </div>
        </div>
      </ng-container>
      <div *ngFor="let result of fullListShow; let i=index;" class="accordion" [id]="'accordion-' + i">
        <div class="mt-0" id="blockFaq">
          <div class="col my-3">
            <p class="uppercase-font m-0">
              <a *ngIf="result.origin == 'sobreNos'" class="btn-link-custom fw-700" [routerLink]="'/sobre-nos'">{{'search.' + result.origin | translate}}<i class="uil uil-arrow-up-right fs-20px ms-2"></i></a>
              <a *ngIf="result.origin == 'tresRios'" class="btn-link-custom fw-700" [routerLink]="'/tres-rios'">{{'search.' + result.origin | translate}}<i class="uil uil-arrow-up-right fs-20px ms-2"></i></a>
              <a *ngIf="result.origin == 'tarifarios'" class="btn-link-custom fw-700" [routerLink]="'/tarifarios'">{{'search.' + result.origin | translate}}<i class="uil uil-arrow-up-right fs-20px ms-2"></i></a>
              <a *ngIf="result.origin == 'descontos'" class="btn-link-custom fw-700" [routerLink]="'/descontos'">{{'search.' + result.origin | translate}}<i class="uil uil-arrow-up-right fs-20px ms-2"></i></a>
              <a *ngIf="result.origin == 'news'" class="btn-link-custom fw-700" [routerLink]="'/noticias'">{{'search.' + result.origin | translate}}<i class="uil uil-arrow-up-right fs-20px ms-2"></i></a>
              <a *ngIf="result.origin == 'faq'" class="btn-link-custom fw-700" [routerLink]="'/faq'">{{'search.' + result.origin | translate}}<i class="uil uil-arrow-up-right fs-20px ms-2"></i></a>
              <a *ngIf="result.origin == 'warnings'" class="btn-link-custom fw-700" [routerLink]="'/'" fragment="warnings">{{'search.' + result.origin | translate}}<i class="uil uil-arrow-up-right fs-20px ms-2"></i></a>
            </p>
          </div>
          <div *ngFor="let item of result.results; let j=index;" class="accordion-item">
            <h2 class="accordion-header" [id]="'resultList-' + i + '-' +j">
              <button title="Botão ir para..." class="accordion-button collapsed" type="button" data-bs-toggle="collapse" [attr.data-bs-target]="'#result-' + i + '-' + j">
                <span *ngIf="result.origin == 'sobreNos'" [innerHTML]="highlightText(item.title)"></span>
                <span *ngIf="result.origin == 'tresRios'" [innerHTML]="highlightText(item.title)"></span>
                <span *ngIf="result.origin == 'tarifarios' && item.date == null" [innerHTML]="highlightText(item.title)"></span>
                <span *ngIf="result.origin == 'tarifarios' && item.date != null" [innerHTML]="highlightText(item.title) + (item.date ? ' (' + item.date + '€)' : '')"></span>
                <span *ngIf="result.origin == 'descontos'" [innerHTML]="highlightText(item.title)"></span>
                <span *ngIf="result.origin == 'news'" [innerHTML]="highlightText(item.title) + (item.date ? ' (' + item.date + ')' : '')"></span>
                <span *ngIf="result.origin == 'warnings'">
                <i *ngIf="item.alert_type == 'Alerta'" class="uil uil-exclamation-triangle color-warning me-2"></i>
                <i *ngIf="item.alert_type == 'Informativo'" class="uil uil-info-circle color-info me-2"></i>
                <i *ngIf="item.alert_type == 'Obras'" class="uil uil-traffic-barrier color-warning me-2"></i>
              </span>
                <span *ngIf="result.origin == 'warnings'" [innerHTML]="highlightText(item.title) + (item.date ? ' (' + item.date + ')' : '')"></span>
                <span *ngIf="result.origin == 'faq'" [innerHTML]="item.group + ': ' + highlightText(item.title) "></span>
              </button>
            </h2>
            <div [id]="'result-' + i + '-' +j" class="accordion-collapse collapse" [attr.data-bs-parent]="'#accordion-' + i  ">
              <div class="accordion-body">
                <p class="mt-3" [innerHTML]="highlightText(item.text)"></p>
                <div *ngIf="result.origin == 'news'" class="mt-auto">
                  <a (click)="goToNews(item.documentId)" class="btn btn-link fw-700 px-0">{{searchInfo.Link_Ler_Noticia}}<i class="uil uil-eye ms-2 fs-20px"></i></a>
                </div>
                <div *ngIf="result.origin == 'warnings'" class="mt-auto">
                  <p *ngIf="item.municipalities" class="mt-3"><strong>{{searchInfo.Municipios}}: </strong><span [innerHTML]="highlightText(item.municipalities)"></span></p>
                  <p *ngIf="item.lines" class="mt-3"><strong>{{searchInfo.Linhas}}: </strong><span [innerHTML]="highlightText(item.lines)"></span></p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="searchReady && fullListSize == 0">
        <div class="col-lg-10 col-12">
          <h6>{{searchInfo.Titulo_Sem_Resultados}}</h6>
          <p [innerHTML]="searchInfo.Pesquisa_Sem_Resultados"></p>
        </div>
      </div>
    </div>
  </section>
</main>

